import { render } from "./LwTourMenu.vue?vue&type=template&id=c6be1264&scoped=true"
import script from "./LwTourMenu.vue?vue&type=script&lang=js"
export * from "./LwTourMenu.vue?vue&type=script&lang=js"

import "./LwTourMenu.vue?vue&type=style&index=0&id=c6be1264&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6be1264"]])

export default __exports__